// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

/* eslint-disable import/prefer-default-export */
import { useAppSelector } from 'Hooks';

const ADMIN_EXTENSIONS = ['.tiff', '.tif', '.kml', '.kmz', '.laz', '.zip'];
const ORDERING_EXTENSIONS = ['.tiff', '.tif', '.las', '.laz', '.kml', '.kmz', '.zip'];
const IMAGERY_EXTENSIONS = ['.tiff', '.tif'];

// What the data upload accepts from the signed-in user: Treasure Chest uploads any data file; a customer who may
// order uploads all of it, one with editorFunctions alone uploads imagery. The upload control and the dialog both
// name the upload from this, so they say the same thing.
export const useAcceptedDataExtensions = (): string[] | undefined => {
  const { resources } = useAppSelector((state) => state.auth);
  if (_ADMIN_) return ADMIN_EXTENSIONS;
  if ('placeOrder' in resources) return ORDERING_EXTENSIONS;
  if ('editorFunctions' in resources) return IMAGERY_EXTENSIONS;
  return undefined;
};
